<template>
  <error-boundary module="employee-review-module">
    <component :is="moduleToRender" />
  </error-boundary>
</template>

<script>
import store from '@/store';
import { COUNTRY } from '@/core/country';
import ReviewModule from '@/modules/review-module.vue';
import ViewModule from '@/modules/view-module.vue';
import ErrorBoundary from '@/components/error-boundary.vue';

export default {
  name: 'EmployeeReviewModule',
  components: { ErrorBoundary, ViewModule, ReviewModule },
  props: {
    document: {
      type: String,
      default: null,
    },
  },
  setup() {
    const moduleToRender =
      store.state.onboarding?.countryCode === COUNTRY.US
        ? ReviewModule
        : ViewModule;

    return {
      moduleToRender,
    };
  },
};
</script>
